var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-label',{attrs:{"text":_vm.status.label,"color":_vm.status.color,"large":_vm.large,"block":_vm.block}})}
var staticRenderFns = []

export { render, staticRenderFns }